import React from 'react';
import { KeyframeLine } from './KeyframeLine';
import type { KeyframeContainerProps } from '../types';
import { KEYFRAME_ITEM_HEIGHT } from '../types/ui.types';
import { TIMELINE_LAYERS } from '@/pages/editor/components/timeline/utils';


export const KeyframeContainer: React.FC<KeyframeContainerProps> = ({
  assetInstanceId,
  assetStartTime,
  assetDuration,
  assetCategory,
  scale,
  isLocked,
      isVisible,
  keyframes = [],
  onKeyframeAdd,
  onKeyframeMove,
  onKeyframeMoveEnd, 
  onKeyframeSelect, 
  isKeyframeEditMode = false,
  isCurrentAssetInEditMode = false,
  selectedKeyframeId,
  itemHeight = KEYFRAME_ITEM_HEIGHT,
  resizeOffset,
  isPlaying = false
}) => {
  // Position keyframes on top of the asset content instead of below
  const calculatedTop = 0; // Overlay on top of the asset

  // During resize, calculate effective asset bounds for keyframe positioning
  // This allows keyframes to be positioned relative to the VISUAL asset bounds
  let effectiveStartTime = assetStartTime;
  let effectiveDuration = assetDuration;
  let containerWidth = assetDuration * scale;
  
  if (resizeOffset) {
    if (resizeOffset.side === 'left') {
      // Left resize: adjust start time and duration to match visual bounds
      effectiveStartTime = assetStartTime + resizeOffset.deltaTime;
      effectiveDuration = assetDuration - resizeOffset.deltaTime;
      containerWidth = effectiveDuration * scale;
    } else {
      // Right resize: adjust duration to match visual bounds
      effectiveDuration = assetDuration + resizeOffset.deltaTime;
      containerWidth = effectiveDuration * scale;
    }
  }

  return (
    <div
      className={`absolute left-0 ${isKeyframeEditMode && !isCurrentAssetInEditMode ? 'opacity-lureo-disabled-opacity' : ''}`}
      data-keyframe-container
      data-asset-id={assetInstanceId}
      style={{
        top: calculatedTop,
        width: `${containerWidth}px`,
        height: `${itemHeight}px`,
        zIndex: isCurrentAssetInEditMode ? TIMELINE_LAYERS.keyframesEditing : TIMELINE_LAYERS.keyframes,
        cursor: !isLocked ? 'pointer' : 'default',
        pointerEvents: 'none',
      }}
    >
      <KeyframeLine
        assetInstanceId={assetInstanceId}
        assetStartTime={effectiveStartTime}
        assetDuration={effectiveDuration}
        assetCategory={assetCategory}
        scale={scale}
        isLocked={isLocked}
        isVisible={isVisible}
        keyframes={keyframes}
        onKeyframeAdd={onKeyframeAdd}
        onKeyframeMove={onKeyframeMove}
        onKeyframeMoveEnd={onKeyframeMoveEnd}
        onKeyframeSelect={onKeyframeSelect}
        isKeyframeEditMode={isKeyframeEditMode}
        isCurrentAssetInEditMode={isCurrentAssetInEditMode}
        selectedKeyframeId={selectedKeyframeId}
        resizeOffset={resizeOffset}
        itemHeight={itemHeight}
        isPlaying={isPlaying}
      />
    </div>
  );
}; 